"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.js
 ** module id = 248
 ** module chunks = 0
 **/